export default {
  BASE_FILE_URL: "https://handygarments.co.za/backend/get-file/",
  // BASE_FILE_URL: "http://localhost:8080/get-file/",
};
